<div class="page-title-area item-bg2">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a href="/" i18n>Home</a></li>
                <li i18n>About</li>
                <li></li>
            </ul>
            <h2 i18n>About</h2>
        </div>
    </div>
</div>

<div class="blog-details-area ptb-100" [class.dark-blog-details-area]="themeService.isDark()">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="blog-details-desc">
                    <div class="article-content">


                        <h2 i18n>Who We Are?</h2>
                        <p>{{about?.text}}</p>

                        <app-vision-mission></app-vision-mission>
                        <app-home-project></app-home-project>
                        <app-home-donor></app-home-donor>
                       

                    </div>

                </div>

            </div>
        </div>
    </div>